import { Helpers } from '../../helpers';
import { ISCADAType } from '../../interfaces/is-c-a-d-a-type';
import { WaterWell } from '../water-well';

export class SCADATypeBase {
  SCADATypeId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  WaterWells_SCADAType?: Array<WaterWell> | null;

  constructor(item?: ISCADAType) {
    if (item) {

      this.SCADATypeId = item.SCADATypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.WaterWells_SCADAType = Helpers.createClassArray(WaterWell, item.WaterWells_SCADAType);
    }
  }
}